module.exports = __webpack_public_path__ + "poppins-medium_0-webfont.346093ec41f0918f3c1e.svg";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/fonts/poppins-medium_0-webfont.svg
// module id = ../../../../../src/assets/fonts/poppins-medium_0-webfont.svg
// module chunks = 2